import { Injectable } from '@angular/core';
import { TranslateService } from '@galaxy/lexicon';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';

@Injectable({ providedIn: 'root' })
export class ApiTriggerOrderService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  /**
   * This is the text that appears in the activity column in the activity table.
   */
  getActivityColumn(_namespace: string, _activity: ActivityInterface): ActivityTableEntry {
    return this.triggerActivityEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.API_ORDER_TRIGGER.ACTIVITY'),
    );
  }

  /**
   * This is the text shown in the automation editor.
   */
  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    // Node display data contains the text to display as well as validation errors.
    // Validation errors appear when the node is rendered.
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.API_ORDER_TRIGGER.WHEN_ACTION'),
      this.noValidationErrorsDetected(),
    );
  }
}
